<template>
	<div style="height: calc(100% - 90px);">
		<div>
			<s-menu :collapsed="collapsed" :menu="menus" theme="dark" mode="inline" @select="onSelect" @click="onClick" style="padding: 16px 0px;"></s-menu>
		</div>
	</div>
</template>

<script>
	import SMenu from './menu.js'
	export default {
		components: {
			SMenu
		},
		data() {
			return {
				routerArr: [],
				collapsed: false,
				menus: [],
				sf: ''
			}
		},
		created() {
      this.sf = localStorage.sf
			this.getRouter()
		},
		watch: {
			$route(to, from) {
				this.menus = this.menuChangeFun(this.menus)
			}
		},
		methods: {
			getRouter() {
				var menus = [{
						path: '/',
						name: 'index',
						meta: {
							title: '首页',
							icon: 'home'
						},
            permissions: ['guanli','gongzuo'],
					},
          {
          	path: '/chejian',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '日报录入',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/fengren',
              name: 'fengren',
              meta: {
                title: '缝纫车间',
              },
            },
            {
              path: '/baozhuang',
              name: 'baozhuang',
              meta: {
                title: '包装车间',
              },
            },
            {
              path: '/chengxing',
              name: 'chengxing',
              meta: {
                title: '成型车间',
              },
            },
            {
              path: '/zuzhuang',
              name: 'zuzhuang',
              meta: {
                title: '组装车间',
              },
            },
            {
              path: '/hanjie',
              name: 'hanjie',
              meta: {
                title: '焊接车间',
              },
            },
            {
              path: '/tuzhuanglinxi',
              name: 'tuzhuanglinxi',
              meta: {
                title: '涂装淋洗车间',
              },
            },
            {
              path: '/tuzhuangliangting',
              name: 'tuzhuangliangting',
              meta: {
                title: '涂装凉亭车间',
              },
            },
            {
              path: '/dadutou',
              name: 'dadutou',
              meta: {
                title: '打堵头车间',
              },
            },
            {
              path: '/bianteng',
              name: 'bianteng',
              meta: {
                title: '编藤车间',
              },
            }]
          },
          {
          	path: '/gongzi',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '工资录入',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/frgz',
              name: 'frgz',
              meta: {
                title: '缝纫工资',
              },
            },{
              path: '/bzgz',
              name: 'bzgz',
              meta: {
                title: '包装工资',
              },
            },{
              path: '/cxgz',
              name: 'cxgz',
              meta: {
                title: '成型工资',
              },
            },{
              path: '/zzgz',
              name: 'zzgz',
              meta: {
                title: '组装工资',
              },
            },{
              path: '/hanjieyuegz',
              name: 'hanjieyuegz',
              meta: {
                title: '焊接工资',
              },
            },{
              path: '/tzgzMb',
              name: 'tzgzMb',
              meta: {
                title: '涂装日工资',
              },
            },{
              path: '/tzgz',
              name: 'tzgz',
              meta: {
                title: '涂装人员工资',
              },
            },{
              path: '/tzddtgzMb',
              name: 'tzddtgzMb',
              meta: {
                title: '涂装打堵头模板',
              },
            },{
              path: '/tzddtgz',
              name: 'tzddtgz',
              meta: {
                title: '涂装打堵头工资',
              },
            }]
          },
          {
          	path: '/form',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '日报表格',
          		icon: 'sliders'
          	},
          	children: [
            {
              path: '/fengrenhetong',
              name: 'fengrenhetong',
              meta: {
                title: '缝纫合同日报表',
              },
            },
            {
              path: '/baozhuanghetong',
              name: 'baozhuanghetong',
              meta: {
                title: '包装合同日报表',
              },
            },
            {
              path: '/chengxinghetong',
              name: 'chengxinghetong',
              meta: {
                title: '成型合同日报表',
              },
            },
            {
              path: '/zuzhuanghetong',
              name: 'zuzhuanghetong',
              meta: {
                title: '组装合同日报表',
              },
            },
            {
              path: '/hanjiehetong',
              name: 'hanjiehetong',
              meta: {
                title: '焊接合同日报表',
              },
            },
            {
              path: '/tuzhuanglinxihetong',
              name: 'tuzhuanglinxihetong',
              meta: {
                title: '涂装淋洗合同日报表',
              },
            },
            {
              path: '/tuzhuangliangtinghetong',
              name: 'tuzhuangliangtinghetong',
              meta: {
                title: '涂装凉亭合同日报表',
              },
            },
            {
              path: '/dadutouhetong',
              name: 'dadutouhetong',
              meta: {
                title: '打堵头合同日报表',
              },
            },
            {
              path: '/biantengtoushi',
              name: 'biantengtoushi',
              meta: {
                title: '编藤透视表格',
              },
            }
            // {
            //   path: '/hanjiebiao',
            //   name: 'hanjiebiao',
            //   meta: {
            //     title: '焊接表格',
            //   },
            // },
            // {
            //   path: '/fengrenbiao',
            //   name: 'fengrenbiao',
            //   meta: {
            //     title: '缝纫表格',
            //   },
            // },
            // {
            //   path: '/fengrengongzi',
            //   name: 'fengrengongzi',
            //   meta: {
            //     title: '缝纫工资表格',
            //   },
            // },
            // {
            //   path: '/biantengbiao',
            //   name: 'biantengbiao',
            //   meta: {
            //     title: '编藤表格',
            //   },
            // },
            // {
            //   path: '/biantenggongzi',
            //   name: 'biantenggongzi',
            //   meta: {
            //     title: '编藤工资表格',
            //   },
            // },
            ]
          },
          {
          	path: '/gongzibiao',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '工资表格',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/frgzb',
              name: 'frgzb',
              meta: {
                title: '缝纫工资表格',
              },
            },{
              path: '/bzgzb',
              name: 'bzgzb',
              meta: {
                title: '包装工资表格',
              },
            },{
              path: '/cxgzb',
              name: 'cxgzb',
              meta: {
                title: '成型工资表格',
              },
            },{
              path: '/zzgzb',
              name: 'zzgzb',
              meta: {
                title: '组装工资表格',
              },
            },{
              path: '/hanjieyuegzb',
              name: 'hanjieyuegzb',
              meta: {
                title: '焊接工资表格',
              },
            },{
              path: '/tzgzb',
              name: 'tzgzb',
              meta: {
                title: '涂装工资表格',
              },
            },{
              path: '/tzddtgzb',
              name: 'tzddtgzb',
              meta: {
                title: '涂装打堵头表格',
              },
            }]
          },
          {
          	path: '/yueribao',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '日报月度汇总',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/yuerbfengren',
              name: 'yuerbfengren',
              meta: {
                title: '缝纫汇总',
              },
            },{
              path: '/yuerbbaozhuang',
              name: 'yuerbbaozhuang',
              meta: {
                title: '包装汇总',
              },
            },{
              path: '/yuerbchengxing',
              name: 'yuerbchengxing',
              meta: {
                title: '成型汇总',
              },
            },{
              path: '/yuerbzuzhuang',
              name: 'yuerbzuzhuang',
              meta: {
                title: '组装汇总',
              },
            },{
              path: '/yuerbhanjie',
              name: 'yuerbhanjie',
              meta: {
                title: '焊接汇总',
              },
            },{
              path: '/yuerblinxi',
              name: 'yuerblinxi',
              meta: {
                title: '涂装淋洗汇总',
              },
            },{
              path: '/yuerbliangting',
              name: 'yuerbliangting',
              meta: {
                title: '涂装凉亭汇总',
              },
            }]
          },
          {
          	path: '/yuegongzi',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '月工资汇总',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/yuefengren',
              name: 'yuefengren',
              meta: {
                title: '缝纫汇总',
              },
            },{
              path: '/yuebaozhuang',
              name: 'yuebaozhuang',
              meta: {
                title: '包装汇总',
              },
            },{
              path: '/yuechengxing',
              name: 'yuechengxing',
              meta: {
                title: '成型汇总',
              },
            },{
              path: '/yuezuzhuang',
              name: 'yuezuzhuang',
              meta: {
                title: '组装汇总',
              },
            },{
              path: '/yuetuzhuang',
              name: 'yuetuzhuang',
              meta: {
                title: '涂装汇总',
              },
            },{
              path: '/yuetuzhuangddt',
              name: 'yuetuzhuangddt',
              meta: {
                title: '打堵头汇总',
              },
            }]
          },
          {
          	path: '/zidingyiribao',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '日报自定义日期',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/zdyrbfengren',
              name: 'zdyrbfengren',
              meta: {
                title: '缝纫汇总',
              },
            },{
              path: '/zdyrbbaozhuang',
              name: 'zdyrbbaozhuang',
              meta: {
                title: '包装汇总',
              },
            },{
              path: '/zdyrbchengxing',
              name: 'zdyrbchengxing',
              meta: {
                title: '成型汇总',
              },
            },{
              path: '/zdyrbzuzhuang',
              name: 'zdyrbzuzhuang',
              meta: {
                title: '组装汇总',
              },
            },{
              path: '/zdyrbhanjie',
              name: 'zdyrbhanjie',
              meta: {
                title: '焊接汇总',
              },
            },{
              path: '/zdyrblinxi',
              name: 'zdyrblinxi',
              meta: {
                title: '涂装淋洗汇总',
              },
            },{
              path: '/zdyrbliangting',
              name: 'zdyrbliangting',
              meta: {
                title: '涂装凉亭汇总',
              },
            }]
          },
          {
          	path: '/admin',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '日报模板',
          		icon: 'sliders'
          	},
          	children: [{
          		path: '/fengrenMb',
          		name: 'fengrenMb',
          		meta: {
          			title: '缝纫模板',
          		},
          	}, {
          		path: '/baozhuangMb',
          		name: 'baozhuangMb',
          		meta: {
          			title: '包装模板',
          		},
          	}, {
          		path: '/chengxingMb',
          		name: 'chengxingMb',
          		meta: {
          			title: '成型模板',
          		},
          	}, {
          		path: '/zuzhuangMb',
          		name: 'zuzhuangMb',
          		meta: {
          			title: '组装模板',
          		},
          	}, {
          		path: '/hanjieMb',
          		name: 'hanjieMb',
          		meta: {
          			title: '焊接模板'
          		},
          	}, {
          		path: '/tuzhuanglinxiMb',
          		name: 'tuzhuanglinxiMb',
          		meta: {
          			title: '涂装淋洗模板'
          		},
          	}, {
          		path: '/tuzhuangliangtingMb',
          		name: 'tuzhuangliangtingMb',
          		meta: {
          			title: '涂装凉亭模板'
          		},
          	}, {
          		path: '/dadutouMb',
          		name: 'dadutouMb',
          		meta: {
          			title: '打堵头模板'
          		},
          	}, {
          		path: '/biantengMb',
          		name: 'biantengMb',
          		meta: {
          			title: '编藤模板'
          		},
          	}, {
          		path: '/zhiweiMb',
          		name: 'zhiweiMb',
          		meta: {
          			title: '职位模板'
          		},
          	}]
          },
          {
          	path: '/gongzimb',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '工资模板',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/fengrengzMb',
              name: 'fengrengzMb',
              meta: {
                title: '缝纫工资模板',
              },
            },{
              path: '/baozhuanggzMb',
              name: 'baozhuanggzMb',
              meta: {
                title: '包装工资模板',
              },
            },{
              path: '/chengxinggzMb',
              name: 'chengxinggzMb',
              meta: {
                title: '成型工资模板',
              },
            },{
              path: '/zuzhuanggzMb',
              name: 'zuzhuanggzMb',
              meta: {
                title: '组装工资模板',
              },
            }]
          },
          {
          	path: '/qita',
          	permissions: ['guanli','gongzuo'],
          	meta: {
          		title: '其他表格',
          		icon: 'sliders'
          	},
          	children: [{
              path: '/huamingce',
              name: 'huamingce',
              meta: {
                title: '花名册',
              },
            },{
              path: '/jixiao',
              name: 'jixiao',
              meta: {
                title: '绩效',
              },
            },{
              path: '/linshiyonggong',
              name: 'linshiyonggong',
              meta: {
                title: '临时用工工资',
              },
            },{
              path: '/heduibiao',
              name: 'heduibiao',
              meta: {
                title: '工资日报核对表',
              },
            }]
          },
          {
          	path: '/member',
          	name: 'member',
          	meta: {
          		title: '人员管理',
          		icon: 'sliders'
          	},
            permissions: ['guanli','gongzuo'],
          },
          {
          	path: '/adminList',
          	name: 'adminList',
          	meta: {
          		title: '账号管理',
          		icon: 'sliders'
          	},
            permissions: ['guanli'],
          },
				];
        
        let checkMenus = []
        for (let i in menus) {
          if(menus[i].permissions.indexOf(this.sf)>-1) {
            checkMenus.push(menus[i])
          }
        }
        
				this.menus = this.menuChangeFun(checkMenus)
			},
			menuChangeFun(menus) {
				let path = this.$route.path
				return menus
			},
			onSelect(obj) {
				// console.log(obj)
			},
			onClick(obj) {
				// console.log(obj)
			},
		}
	}
</script>

<style scoped="scoped">

</style>
